<div class="ui-g-12">
  <h1 class="text-center">{{ 'rolesManagement.rolesManagement' | translate }}</h1>
</div>

<div class="ui-g-12" style="background-color: #fff;">
  <!-- Select Ruoli -->
  <div class="ui-g-12 ui-md-3">
    <h2>{{ 'rolesManagement.selectRole' | translate }}</h2>
    <p-dropdown
      [options]="roles"
      [style]="{'width':'100%'}"
      [(ngModel)]="selectedRole">
    </p-dropdown>
  </div>
  <div class="ui-g-12 ui-md-1"></div>
  <!-- Checkbox Applications -->
  <div class="ui-g-12 ui-md-4">
    <h2>{{ 'rolesManagement.filterApp' | translate }}</h2>
    <div *ngFor="let app of applications" class="application-item">
      <p-checkbox
        class="ch-checkbox"
        name="selectedApplications"
        value="{{ app.applicationId }}"
        [(ngModel)]="selectedApplications"
        (onChange)="filterPermissions(permissions)"
        [disabled]="!selectedRole"
      >
      </p-checkbox>
      <span [ngStyle]="{'opacity': !selectedRole ? '.35' : '1'}">{{app.applicationName }}</span>
    </div>
  </div>
  <!-- Select Profilo -->
  <div class="ui-g-12 ui-md-3">
    <h2>{{ 'rolesManagement.loadProfile' | translate }}</h2>
    <p-dropdown
      id="profile-select"
      [options]="profiles"
      [style]="{'width':'100%'}"
      [(ngModel)]="selectedProfileId"
      (onChange)="loadProfile()"
      [disabled]="!selectedRole || !selectedApplications || selectedApplications.length === 0">
    </p-dropdown>
  </div>
  <div class="ui-g-12 ui-md-1"></div>
</div>

<div class="ui-g-12" style="background-color: #fff;">
  <!-- Button Crea Ruolo -->
  <div class="ui-g-12 ui-md-4">
    <button
      pButton
      class="create-btn"
      [routerLink]="['/roles']"
      label="{{ 'rolesManagement.createRole' | translate | uppercase }}">
    </button>
  </div>
  <!-- Button Visualizza Permission -->
  <div class="ui-g-12 ui-md-4">
    <button
      pButton
      class="create-btn"
      (click)="showPermissions()"
      label="{{ 'rolesManagement.showPermission' | translate | uppercase }}"
      [disabled]="!selectedRole">
    </button>
  </div>
  <div class="ui-g-12 ui-md-4"></div>
</div>
<!-- Tabelle Permission -->
<div class="ui-g-12" *ngIf="selectedRole && permissionsToShow && permissionsToShow.length > 0">
  <div class="ui-g-12" *ngFor="let permission of permissionsToShow">
    <app-kontable
      class="permission-table"
      title="{{ permission.application_name }}"
      [columns]="[
        {field: 'associated', title: '', bodyTemplate: associatedTemplate, filterType: noFilter, sortable: false},
        {field: 'operation', title: 'operation'},
        {field: 'descr', title: 'common.description'},
        {field: 'type', title: 'common.type'},
        {field: 'allowsGET', title: 'GET', bodyTemplate: getTemplate, filterType: noFilter, sortable: false},
        {field: 'allowsPOST', title: 'POST', bodyTemplate: postTemplate, filterType: noFilter, sortable: false},
        {field: 'allowsPUT', title: 'PUT', bodyTemplate: putTemplate, filterType: noFilter, sortable: false},
        {field: 'allowsDELETE', title: 'DELETE', bodyTemplate: deleteTemplate, filterType: noFilter, sortable: false}
      ]"
      [source]="permission.permissions"
      [showRecoverButton]="false"
      [showInfoButton]="false"
      [showAddButton]="false"
      [showDeleteButton]="false"
      [showDetailsButton]="false"
      [showEditButton]="false"
      [showReport]="false"
      [showGlobalFilter]="false"
      [DefaultRowsPerPage]="5"
    >
    <ng-template #associatedTemplate data-testid="associatedTemplate" let-row>
      <p-checkbox
        class="ch-checkbox"
        [(ngModel)]="row.associated"
        [binary]="true"
        (onChange)="permissionRow(row)">
      </p-checkbox>
    </ng-template>
      <ng-template #getTemplate data-testid="getTemplate" let-row>
        <p-checkbox
          class="ch-checkbox"
          [(ngModel)]="row.allowsGET"
          [binary]="true">
        </p-checkbox>
      </ng-template>
      <ng-template #postTemplate data-testid="postTemplate" let-row>
        <p-checkbox
          class="ch-checkbox"
          [(ngModel)]="row.allowsPOST"
          [binary]="true">
        </p-checkbox>
      </ng-template>
      <ng-template #putTemplate data-testid="putTemplate" let-row>
        <p-checkbox
          class="ch-checkbox"
          [(ngModel)]="row.allowsPUT"
          [binary]="true">
        </p-checkbox>
      </ng-template>
      <ng-template #deleteTemplate data-testid="deleteTemplate" let-row>
        <p-checkbox
          class="ch-checkbox"
          [(ngModel)]="row.allowsDELETE"
          [binary]="true">
        </p-checkbox>
      </ng-template>
    </app-kontable>
  </div>
  <!-- Button Cancella -->
  <div class="ui-g-12 ui-md-4">
    <button
      pButton
      class="create-btn"
      (click)="resetPermissions()"
      label="{{ 'common.delete' | translate | uppercase }}"
      [disabled]="!selectedRole || !permissionsToShow || permissionsToShow.length === 0">
    </button>
  </div>
  <!-- Button Salva Ruolo -->
  <div class="ui-g-12 ui-md-4 text-right">
    <button
      pButton
      class="create-btn"
      (click)="saveRole()"
      label="{{ 'rolesManagement.saveRole' | translate | uppercase }}"
      [disabled]="!selectedRole || !permissionsToShow || permissionsToShow.length === 0">
    </button>
  </div>
  <!-- Button Salva Profilo -->
  <div class="ui-g-12 ui-md-4 text-right">
    <button
      pButton
      class="create-btn"
      (click)="showSaveProfileDialog = true"
      label="{{ 'rolesManagement.saveProfile' | translate | uppercase }}"
      [disabled]="!permissionsToShow || permissionsToShow.length === 0">
    </button>
  </div>
</div>

<!-- Modale Salva Profilo -->
<p-dialog
  *ngIf="showSaveProfileDialog"
  [(visible)]="showSaveProfileDialog"
  [modal]="true"
  header="{{'rolesManagement.saveProfile' | translate}}"
  [minWidth]="500"
  [draggable]="false"
  [resizable]="false">
  <form *ngIf="saveProfileForm" [formGroup]="saveProfileForm" [ngClass]="{'invalid-submit': invalidSubmit}">
    <div class="ui-g-12">
      <span class="label required">{{ 'common.name' | translate }}</span>
      <input id="name" name="name" formControlName="name" type="text" pInputText />
      <span class="input-error-notification" *ngIf="invalidSubmit && saveProfileForm.controls['name'].errors?.required">{{  'common.required_error' | translate }}</span>
    </div>
    <div class="ui-g-12">
      <span class="label required">{{ 'common.description' | translate }}</span>
      <textarea id="description" name="description" formControlName="description" pInputTextarea rows="10" cols="60"></textarea>
      <span class="input-error-notification" *ngIf="invalidSubmit && saveProfileForm.controls['description'].errors?.required">{{  'common.required_error' | translate }}</span>
    </div>
  </form>
  <button
    pButton
    class="create-btn"
    (click)="saveProfile()"
    label="{{ 'common.save' | translate | uppercase }}">
  </button>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/roles-management/roles-management.component.html